import BaseService from "./BaseService";
import { RestApiResponse } from "./RestApi";
import { BaseResponseAttributes } from "../attributes/base-attributes";
import CountryService from "./CountryService";

export class RaffleDrawEntryService extends BaseService {
  static async supportedCountries(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return CountryService.getPublicApiClient().get("raffle_draw_entries");
  }

  static getRaffleDraw(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return RaffleDrawEntryService.getApiClient().get(`admin/raffle-draws`);
  }

  static getRaffleDrawWithParticipant(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return RaffleDrawEntryService.getApiClient().get(
      `admin/raffle-draws-entries/get/get-raffle-draw-with-participant`
    );
  }

  static updateWinnersStatus(
    data: any[]
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return RaffleDrawEntryService.getApiClient().post(
      `admin/raffle-draws-entries/update-winners-status`,
      data
    );
  }
}

export default RaffleDrawEntryService;
